
const tableColMapping = {};
const tableColumnsMapping = () => {
    // Mapping for intrastat
    tableColMapping['intrastat'] = [
        {
            header: "intrastat_manual_document_intrastat_code",
            accessor: 'intrastatCode'
        },
        {
            header: "intrastat_manual_document_vat_number_supplier",
            accessor: 'vatNumberSupplier'
        },
        {
            header: "intrastat_manual_document_vat_number_customer",
            accessor: 'vatNumberCustomer'
        },
        {
            header: "intrastat_manual_document_quantity1",
            accessor: 'quantity1'
        },
        {
            header: "intrastat_manual_document_unit1",
            accessor: 'unit1'
        },
        {
            header: "intrastat_manual_document_quantity2",
            accessor: 'quantity2'
        },
        {
            header: "intrastat_manual_document_unit2",
            accessor: 'unit2'
        },
        {
            header: "intrastat_manual_document_transaction_type",
            accessor: 'transactionType'
        },
        {
            header: "intrastat_manual_document_commercial_value",
            accessor: 'commercialValue'
        },
        {
            header: "intrastat_manual_document_delivery_condition",
            accessor: 'deliveryCondition'
        },
        {
            header: "intrastat_manual_document_statistical_value",
            accessor: 'statisticalValue'
        },
        {
            header: "intrastat_manual_document_mode_of_transport",
            accessor: 'modeOfTransport'
        },
        {
            header: "intrastat_manual_document_country_dispatch",
            accessor: 'countryDispatch'
        },
        {
            header: "intrastat_manual_document_country_arrival",
            accessor: 'countryArrival'
        },
        {
            header: "intrastat_manual_document_region_dispatch",
            accessor: 'regionDispatch'
        },
        {
            header: "intrastat_manual_document_region_arrival",
            accessor: 'regionArrival'
        },
        {
            header: "intrastat_manual_document_harbour_dispatch",
            accessor: 'harbourDispatch'
        },
        {
            header: "intrastat_manual_document_harbour_arrival",
            accessor: 'harbourArrival'
        },
        {
            header: "intrastat_manual_document_statistical_procedure",
            accessor: 'statisticalProcedure'
        },
        {
            header: "intrastat_manual_document_country_of_origin",
            accessor: 'countryOfOrigin'
        }
    ]

    // Mapping for ecLisitng
    tableColMapping['ecListing'] = [
        {
            header: "ecListing_manual_document_vat_number",
            accessor: 'vatNumber'
        },
        {
            header: "ecListing_manual_document_amount",
            accessor: 'amount'
        },
        {
            header: "ecListing_manual_document_ec_type",
            accessor: 'listingType'
        },
        {
            header: "ecListing_manual_document_listing_type",
            accessor: 'lineListingType'
        },
        {
            header: "ecListing_manual_document_service_code",
            accessor: 'serviceCode'
        },
        {
            header: "ecListing_manual_document_customerName",
            accessor: 'customerName'
        },
        {
            header: "ecListing_manual_document_originalTradingPartnerVATNumber",
            accessor: 'originalTradingPartnerVATNumber'
        },
        {
            header: "ecListing_manual_document_originalTradingPartnerName",
            accessor: 'originalTradingPartnerName'
        },
        {
            header: "ecListing_manual_document_coSDate",
            accessor: 'coSDate'
        }
    ]

    return tableColMapping;
}

export const getTableColumMapping = reportType => {
    const result = tableColumnsMapping();
    return result[reportType];
}